import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { BoilerDetails } from '../types/boiler-details';
import { FuelFill } from '../types/fuel-fill';
import { FuelType } from '../types/fuel-type';
import { Hub } from '../types/hub';
import { HubSubMenuComponent } from './hub-menu-component';

@Component({
  selector: 'hub-boiler-details',
  templateUrl: `./hub-oil-details.component.html`,
  styles: [
    `div, span {display: inline-block;}`,
    `div.displayrow, div.editrow, #fills {display: block;}`,
    `.boiler_details{ display: block; padding: 0.1em;}`,
    `select, input {min-width: inherit; width: inherit;}`,
    `mat-form-field {min-width: 19em; width: 100%; margin: 0 0.5em 0 0.5em;}`,
    `.center {text-align: center;}`,
    `.with_left_margin {min-width: 4em; margin: 0 0.2em 0 2em; }`,
    `.number {min-width: 7em; width: 7em; margin: 0 0.5em 0 0.5em; text-align: right;}`,
    `.timestamp {min-width: 11em; width: 11em; margin: 0 0.5em 0 0.5em;}`,
    `.panel {width: 100%; display: block; text-align: center; left: unset; position: unset;}`,
    `.panel button {margin: 0.2em 0 0.2em 1em;}`,
    `.editable {background-color: #e0e0e0;}`,
    `li span.actions { vertical-align: middle; width: fit-content; line-height: 1.8em}`,
    `span.actions mat-icon { margin: 0.2em;}`,
    `@media screen and (min-device-width: 800px) {
      mat-form-field{min-width: 25em; width: 25em;}
      .panel {display: inline-block; position: relative; top: 0; left: 4em; width: fit-content;}
    }`,
  ]
})

export class HubOilDetailsComponent implements OnInit {
  @Input() inHub: Hub;
  @Output() boiler_saved = new EventEmitter<boolean>();
  fuels: FuelType[];
  hubId: number;
  hub: Hub;
  boiler: BoilerDetails;
  fuel_type_description: string;
  fills: FuelFill[];
  errorMessage: string[];
  editable = false;
  newFill: FuelFill;

  constructor(
    private route: ActivatedRoute,
    private hubService: HubService,
  ) { }

  ngOnInit() {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.hubService.getLookupTable('fuel_types').subscribe((fuels: FuelType[]) => this.fuels = fuels);
    this.switchHub();
  }

  switchHub(): void {
    this.route.params.subscribe(
      (params: Params) => {
        this.hubId = +params['hubid'];
        if (this.hubId) {
          this.hubService.getHubBoiler(this.hubId).subscribe(
            boiler => {
              if (!boiler.fuel_rate || !boiler.hubid) {
                this.editable = true;
                boiler.hubid = this.hubId;
                boiler.fuel_rate = 1.97;
                boiler.tank_capacity = 1200;
                boiler.energy_output = 22.5;
              } else {
                this.fuel_type_description = "Unknown";
                for( let i=0; i<this.fuels.length; i++) {
                  if (this.fuels[i].fuel_type_id == boiler.fuel_type_id) {
                    this.fuel_type_description = this.fuels[i].fuel_type_description;
                  }
                }
              }
              this.boiler = boiler;
              this.hubService.getHubFills(this.hubId).subscribe(
                fills => this.fills = fills,
                error => this.errorMessage = <any>error,
              );
            },
            error => this.errorMessage = <any>error,
          );
        }
      }
    );
    this.hub = HubSubMenuComponent.getHub()
  }

  isValid(): boolean {
    return !!this.boiler.hubid && !!this.boiler.fuel_rate && !!this.boiler.fuel_type_id;
  }

  save(): void {
    let boiler = this.boiler;
    if (!boiler.fuel_type_id || boiler.fuel_type_id < 1) {
      this.errorMessage = ["A fuel type must be selected."];
      return;
    }
    boiler.fuel_rate = Number(boiler.fuel_rate);
    boiler.tank_capacity = Number(boiler.tank_capacity);
    boiler.energy_output = Number(boiler.energy_output);
    boiler.aga_flow_rate = Number(boiler.aga_flow_rate);
    this.hubService.writeBoiler(this.boiler)
      .subscribe(() => {
        this.editable = false;
        this.boiler_saved.emit(true);
      });
  }

  edit(): void {
    this.editable = true;
  }

  cancel(): void {
    this.editable = false;
    this.switchHub();
  }

  addFuelFill(): void {
    this.newFill = <FuelFill>{
      fill_timestamp: (new Date()).toISOString(),
      hubid: this.hubId,
    };
  }

  onFillSaved(e: Event): void {
    this.newFill = undefined;
    this.switchHub();
  }

  deleteFuelFill(f: FuelFill): void {
    this.hubService.deleteFuelFill(f)
      .subscribe(
        () => {
          this.switchHub();
          this.errorMessage = ["Fuel fill deleted."];
        },
        (e: any) => this.errorMessage.push(e as string)
      );
  }
}
